import { hasClass } from '@opten/dom/has-class';
import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { getOffset } from '@opten/dom/get-offset';
import { Collapse } from '@opten/collapse/initializer';
import { getSelectorElementFromElement } from '@opten/dom/get-selector-element-from-element';
import { getCss } from '@opten/dom/get-css';
import { parseCssUnit } from '@opten/number/parse-css-unit';
import { getStickyOffset } from '../utilities/scroll-helper';
import { isDesktop, isPad } from '../utilities/detection';

@Component({ className: 'js-anchor' })
export class AnchorComponent implements OnInit {


    constructor(private element: HTMLElement) {

    }

    onInit() {
        this.check();
        window.addEventListener('hashchange', () => this.check());
        window.addEventListener('popstate', () => this.check());

    }

    check() {
        if (this._canScroll()) {
            this._scroll();
        }
    }

    private _canScroll(): boolean {
        const hash = window.location.hash;

        return hash && hash.indexOf('#anchor-') !== -1;
    }

    private getElement(): HTMLElement {
        if (this._canScroll()) {
            return this.element.querySelector(
                `[data-anchor='${window.location.hash.substring(1)}']`
            );
        }

        return null;
    }

    private _scroll() {
        const element = this.getElement();

        if (element) {
            // check if it's an accordion element, so we can open it
            if (element.getAttribute('data-toggle') === 'collapse') {
                const target = getSelectorElementFromElement(
                    element,
                    'data-target',
                    true
                );

                if (target) {
                    const api = Collapse.getInstance(target);

                    // check if the collapse is already open
                    // because then the shown event might not be triggered!
                    if (api.isOpen()) {
                        this._animate();
                    } else {
                        target.addEventListener(
                            'shown.opten.collapse',
                            this._handleCollapse
                        );

                        api.show();
                    }
                } else {
                    // fallback
                    this._animate();
                }
			}
			else if(hasClass(element,'js-tab-content')){
				if(isDesktop()){
					if(hasClass(element,'is-visible') == false){
						const tabTarget = element.getAttribute('data-tab');
						const tabLink = this.element.querySelector(
							`[data-tab-action='${tabTarget}']`
						);
						element.addEventListener(
                            'shown.merbag.tabs',
                            this._handleCollapse
						);
						tabLink.dispatchEvent(new Event('click'));
					}
					else{
						this._animate();
					}
				}
				else{
					const api = Collapse.getInstance(element);

                    // check if the collapse is already open
                    // because then the shown event might not be triggered!
                    if (api.isOpen()) {
                        this._animate();
                    } else {
                        element.addEventListener(
                            'shown.opten.collapse',
                            this._handleCollapse
                        );

                        api.show();
                    }
				}
			}
			else {
                // otherwise just scroll to the element...
                this._animate();
            }
        }
    }

    private _animate() {
        const element = this.getElement();

        if (element) {
            let offset = getOffset(element).top();

            offset += parseCssUnit(getCss(element, 'margin-top')) * -1;
            offset += getStickyOffset() * -1;

			offset = Math.round(offset);
			if(hasClass(element,'js-tab-content') || hasClass(element,'section--large__bottom')){
				offset -= isDesktop() ? 100 : 65;
			}

            window.scrollTo(0, offset);
        }
    }

    private _handleCollapse = () => {
        this._animate();
    }

}
